import { ArbeitszeitenPausenart } from '@/domain/arbeitszeiten/entities';
import {
  faBookSection,
  faCalendar,
  faHand,
  faRobot,
  faSmoking,
  faStamp,
} from '@fortawesome/pro-regular-svg-icons';

export function getPausenartIndicator(pausenart: ArbeitszeitenPausenart) {
  if (pausenart === ArbeitszeitenPausenart.Automatisch) {
    return faRobot;
  }
  if (pausenart === ArbeitszeitenPausenart.Gesetzlich) {
    return faBookSection;
  }
  if (pausenart === ArbeitszeitenPausenart.Gestempelt) {
    return faStamp;
  }
  if (pausenart === ArbeitszeitenPausenart.Manuell) {
    return faHand;
  }
  if (pausenart === ArbeitszeitenPausenart.Rauchen) {
    return faSmoking;
  }
  // Pausenart Schicht
  return faCalendar;
}
